// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__2DIg_"};